var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfinedspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,47.06v3.44h3.77v-3.44H1.52C1.51,47.06,1.51,47.06,1.5,47.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,41.48v4.59c0.01,0,0.01,0,0.02,0h3.75v-4.58H1.52C1.51,41.48,1.51,41.48,1.5,41.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.98,6.52l-1.02-3.66c-2.08,0.72-4.03,1.72-5.81,2.95l1.96,3.25C15.59,8,17.23,7.15,18.98,6.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,9.66l-1.97-3.27c-1.67,1.25-3.17,2.72-4.47,4.35l2.75,2.63C10.67,11.98,11.91,10.73,13.3,9.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,30.31v4.59c0.01,0,0.01,0,0.02,0h3.75v-4.58H1.52C1.51,30.32,1.51,30.31,1.5,30.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,35.89v4.59c0.01,0,0.01,0,0.02,0h3.75V35.9H1.52C1.51,35.9,1.51,35.89,1.5,35.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.5,5.3V1.51c-2.29,0.05-4.5,0.4-6.59,1.04l1.02,3.64C21.69,5.64,23.57,5.34,25.5,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.09,2.55C31,1.91,28.79,1.56,26.5,1.51V5.3c1.93,0.05,3.81,0.34,5.58,0.89L33.09,2.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.9,9.06l1.96-3.25c-1.78-1.23-3.73-2.22-5.81-2.95l-1.02,3.66C34.77,7.15,36.41,8,37.9,9.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.38,27.19v12h19.23v-12c0-5.3-4.31-9.62-9.61-9.62C20.7,17.57,16.38,21.89,16.38,27.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,26v3.32c0.01,0,0.01,0,0.02,0h3.75V26c0-0.34,0.03-0.68,0.05-1.02l-3.74-0.96 C1.53,24.67,1.5,25.33,1.5,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4,13.37l2.75-2.63c-1.3-1.63-2.8-3.09-4.47-4.35L38.7,9.66C40.09,10.73,41.33,11.98,42.4,13.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.73,30.32v4.58h3.75c0.01,0,0.01,0,0.02,0v-4.59c-0.01,0-0.01,0-0.02,0H46.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.73,35.9v4.58h3.75c0.01,0,0.01,0,0.02,0v-4.59c-0.01,0-0.01,0-0.02,0H46.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.63,23.96l3.68-0.95c-0.23-1.87-0.66-3.69-1.29-5.41l-3.36,1.86C46.14,20.9,46.48,22.4,46.63,23.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.73,26v3.31h3.75c0.01,0,0.01,0,0.02,0V26c0-0.67-0.03-1.32-0.09-1.98l-3.73,0.96 C46.7,25.32,46.73,25.66,46.73,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43,14.17c0.94,1.34,1.71,2.8,2.31,4.34l3.34-1.85c-0.76-1.83-1.73-3.56-2.89-5.14L43,14.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.24,11.53c-1.16,1.58-2.13,3.3-2.89,5.14l3.34,1.85c0.6-1.55,1.37-3,2.31-4.34L6.24,11.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.73,41.48v4.58h3.75c0.01,0,0.01,0,0.02,0v-4.59c-0.01,0-0.01,0-0.02,0H46.73z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.11,40.19 6.9,50.5 45.11,50.5 35.89,40.19  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.69,23.01l3.69,0.95c0.15-1.56,0.49-3.06,0.97-4.49l-3.36-1.86C2.35,19.33,1.92,21.14,1.69,23.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.73,47.06v3.44h3.77v-3.44c-0.01,0-0.01,0-0.02,0H46.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.22,10.4c-0.04-0.05-0.1-0.08-0.15-0.1c-1.46-1.86-3.17-3.52-5.08-4.91c-0.04-0.08-0.09-0.15-0.17-0.19 c-0.06-0.04-0.13-0.06-0.19-0.07c-2.03-1.42-4.27-2.56-6.67-3.35c-0.03-0.02-0.07-0.04-0.11-0.06c-0.02-0.01-0.05,0-0.07,0 C31.32,0.93,28.71,0.5,26,0.5c-2.71,0-5.32,0.43-7.78,1.22c-0.02,0-0.04,0-0.07,0c-0.04,0.01-0.07,0.03-0.11,0.05 c-2.4,0.79-4.64,1.93-6.67,3.35c-0.07,0.01-0.13,0.03-0.19,0.07c-0.08,0.05-0.13,0.12-0.17,0.19C9.1,6.78,7.39,8.43,5.93,10.3 c-0.05,0.03-0.11,0.06-0.15,0.1c-0.07,0.07-0.1,0.15-0.12,0.24C2.43,14.91,0.5,20.23,0.5,26v25c0,0.28,0.22,0.5,0.5,0.5h4.75 c0.01,0,0.01,0,0.02,0h40.46c0,0,0.01,0,0.01,0H51c0.28,0,0.5-0.22,0.5-0.5V26c0-5.76-1.92-11.09-5.16-15.36 C46.32,10.55,46.28,10.47,46.22,10.4z M40.67,6.39c1.67,1.25,3.17,2.72,4.47,4.35l-2.75,2.63c-1.07-1.39-2.31-2.63-3.69-3.71 L40.67,6.39z M34.04,2.86c2.08,0.72,4.03,1.72,5.81,2.95L37.9,9.06c-1.49-1.05-3.13-1.9-4.88-2.53L34.04,2.86z M26.5,1.51 c2.29,0.05,4.5,0.4,6.59,1.04l-1.02,3.64c-1.77-0.54-3.64-0.84-5.58-0.89V1.51z M26,17.57c5.3,0,9.61,4.32,9.61,9.62v12H16.38v-12 C16.38,21.89,20.7,17.57,26,17.57z M25.5,1.51V5.3c-1.93,0.05-3.81,0.34-5.58,0.89l-1.02-3.64C21,1.91,23.21,1.56,25.5,1.51z  M17.96,2.86l1.02,3.66C17.23,7.15,15.59,8,14.1,9.05l-1.96-3.25C13.93,4.58,15.88,3.59,17.96,2.86z M11.33,6.39l1.97,3.27 c-1.38,1.08-2.62,2.32-3.69,3.71l-2.75-2.63C8.16,9.11,9.66,7.64,11.33,6.39z M5.27,50.5H1.5v-3.44c0.01,0,0.01,0,0.02,0h3.75V50.5 z M5.27,46.06H1.52c-0.01,0-0.01,0-0.02,0v-4.59c0.01,0,0.01,0,0.02,0h3.75V46.06z M5.27,40.48H1.52c-0.01,0-0.01,0-0.02,0v-4.59 c0.01,0,0.01,0,0.02,0h3.75V40.48z M5.27,34.9H1.52c-0.01,0-0.01,0-0.02,0v-4.59c0.01,0,0.01,0,0.02,0h3.75V34.9z M5.27,26v3.31 H1.52c-0.01,0-0.01,0-0.02,0V26c0-0.67,0.03-1.32,0.09-1.98l3.74,0.96C5.31,25.32,5.27,25.66,5.27,26z M5.38,23.96l-3.69-0.95 c0.23-1.87,0.66-3.69,1.29-5.41l3.36,1.86C5.87,20.91,5.53,22.41,5.38,23.96z M3.35,16.67c0.76-1.83,1.73-3.56,2.89-5.14L9,14.18 c-0.94,1.34-1.71,2.8-2.31,4.34L3.35,16.67z M6.9,50.5l9.21-10.31h19.78l9.22,10.31H6.9z M50.5,50.5h-3.77v-3.44h3.75 c0.01,0,0.01,0,0.02,0V50.5z M50.5,46.07c-0.01,0-0.01,0-0.02,0h-3.75v-4.58h3.75c0.01,0,0.01,0,0.02,0V46.07z M50.5,40.48 c-0.01,0-0.01,0-0.02,0h-3.75V35.9h3.75c0.01,0,0.01,0,0.02,0V40.48z M50.5,34.9c-0.01,0-0.01,0-0.02,0h-3.75v-4.58h3.75 c0.01,0,0.01,0,0.02,0V34.9z M50.5,26v3.32c-0.01,0-0.01,0-0.02,0h-3.75V26c0-0.35-0.04-0.68-0.05-1.02l3.73-0.96 C50.47,24.67,50.5,25.33,50.5,26z M50.31,23.01l-3.68,0.95c-0.15-1.56-0.49-3.06-0.97-4.49l3.36-1.86 C49.65,19.33,50.08,21.14,50.31,23.01z M45.31,18.52c-0.6-1.55-1.37-3-2.31-4.34l2.76-2.64c1.16,1.58,2.13,3.3,2.89,5.14 L45.31,18.52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfinedspace);
export default __webpack_public_path__ + "static/media/confinedspace.71b43a61005bc091a154164e28f47ab5.svg";
export { ForwardRef as ReactComponent };